import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import { Link } from 'react-router-dom';
import { PageHeading } from 'components/common';

const TitleContainer = styled.h1`
    color: ${theme.colors.gray_darker};
    font-family: ${theme.fonts.regular};
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 12px;
`;

const GroupTitleLink = styled(Link)`
    color: ${theme.colors.gray_darker};

    &:hover {
        color: inherit;
    }
`;

const Between = styled.span`
    margin: 0 6px;
`;

interface GroupTitleProps {
    isActive: boolean;
}

const GroupTitle = styled.span<GroupTitleProps>`
    color: ${props => (props.isActive ? theme.colors.main : 'auto')};
    cursor: ${props => (props.isActive ? 'auto' : 'pointer')};
`;

interface BreadcrumbItem {
    text: string;
    onClickFunction?: () => void;
    linkTo?: string;
}

interface Props {
    breadcrumbItems: BreadcrumbItem[];
}

function BreadcrumbsTitle({ breadcrumbItems }: Props) {
    return (
        <TitleContainer>
            {breadcrumbItems.length === 1 ? (
                <PageHeading>{breadcrumbItems[0].text}</PageHeading>
            ) : (
                breadcrumbItems.map((crumb: BreadcrumbItem, index) => {
                    if (index < breadcrumbItems.length - 1) {
                        return (
                            <React.Fragment key={crumb.text + index}>
                                {crumb.linkTo ? (
                                    <GroupTitleLink to={crumb.linkTo}>
                                        {crumb.text}
                                    </GroupTitleLink>
                                ) : (
                                    <GroupTitle
                                        isActive={false}
                                        onClick={() =>
                                            crumb.onClickFunction
                                                ? crumb.onClickFunction()
                                                : undefined
                                        }
                                    >
                                        {crumb.text}
                                    </GroupTitle>
                                )}
                                <Between>{'>'}</Between>
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <GroupTitle
                                key={crumb.text + index}
                                isActive={true}
                                onClick={() =>
                                    crumb.onClickFunction
                                        ? crumb.onClickFunction()
                                        : undefined
                                }
                            >
                                {crumb.text}
                            </GroupTitle>
                        );
                    }
                })
            )}
        </TitleContainer>
    );
}

export default BreadcrumbsTitle;
